import React, { CSSProperties, ReactNode } from 'react';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Space } from 'antd';

type TColorIconType = {
  border?: boolean;
  color?: string;
};

const ColorIcon = styled.span<TColorIconType>`
  display: inline-block;
  width: 8px;
  height: 8px;
  max-height: 8px;
  border-radius: 8px;

  ${({ border }: TColorIconType) =>
    border &&
    css`
      border: solid 1px rgba(0, 0, 0, 0.2);
    `}
  ${({ color }: TColorIconType) =>
    color &&
    css`
      background: ${color};
    `}
`;

type TIconTextParams = {
  border?: boolean;
  icon?: ReactNode | string;
  message: string | string[];
  style?: CSSProperties;
};

export default function IconText({ message, icon, style, border }: TIconTextParams) {
  return (
    <Space style={style}>
      {typeof icon === 'string' ? <ColorIcon border={border} color={icon} /> : icon}
      <span>{message}</span>
    </Space>
  );
}
